module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Dados do Recebedor","name":"Nome","email":"Email","phone":"Telefone"},"en-US":{"title":"Recipient Data","name":"Name","email":"Email","phone":"Phone"}}')
  delete Component.options._Ctor
}
